import React, { useState } from "react";
import { Form } from "semantic-ui-react";
import { initialValues, validationSchema } from "./Newsletter.form";
import { useFormik } from "formik";
import { Newsletter as NewsletterController } from "../../../../api";
import "./Newsletter.scss";

const newslettercontroller = new NewsletterController();

export function Newsletter() {
  const [success, setSuccess] = useState(false);

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: async (formValue) => {
      setSuccess(false);

      try {
        console.log("formValue", formValue, formValue.email);
        await newslettercontroller.registerEmail(formValue.email);
        formik.resetForm();
        setSuccess(true);
      } catch (error) {
        console.error(error);
      }
    },
  });

  return (
    <div className="footer-newsletter">
      <h4>Apuntate a la Newsletter</h4>
      <Form onSubmit={formik.handleSubmit}>
        <Form.Input
          name="email"
          placeholder="Introduce tu email..."
          onChange={formik.handleChange}
          value={formik.values.email}
          error={formik.errors.email}
        />
        <Form.Button type="submit" primary fluid loading={formik.isSubmitting}>
          ¡Suscribirme!
        </Form.Button>
        {success && <p className="success">¡Email registrado correctamente!</p>}
      </Form>
    </div>
  );
}
